// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent[data-v-ec010850]{font-size:14px}.messageMain[data-v-ec010850]{position:absolute;left:140px;margin-right:40px}.codeBox[data-v-ec010850]{width:85%;float:right}.messageBox[data-v-ec010850]{padding:12px 5px 12px 0;font-size:14px}textarea[data-v-ec010850]{resize:none}p[data-v-ec010850]{font-family:Microsoft yahei}.textLeft[data-v-ec010850]{width:15%;height:40px;float:left}.textRight[data-v-ec010850]{height:40px;width:85%;margin-left:15%;overflow:hidden}", ""]);
// Exports
module.exports = exports;
